export default "__VITE_ASSET__BL3yTB5f__"